import { uploadProductImages } from "@/infrastructure/services/productService";
import type { ProductImage } from "@/pages/adicionar-produtos/types";
import { useCallback } from "react";

export function useProductImageUpload() {
  const uploadAndConfirmImages = useCallback(
    async (
      productId: number,
      images: { image: ProductImage; principal: boolean }[],
    ) => {
      if (!images.length) return new Map<string, string>();
      const ids = await uploadProductImages(
        productId,
        images.map(({ image, principal }) => ({
          file: image.file!,
          altText: image.name,
          principal,
        })),
      );

      /*
       * ROLLBACK: versão anterior do hook:
       * const prepared = await createProductImageUploadUrls(productId, {
       *   imagens: images.map(({ image, principal }) => ({
       *     content_type: image.file!.type,
       *     tamanho_bytes: image.file!.size,
       *     alt_text: image.name,
       *     principal,
       *   })),
       * });
       * const ids = await uploadProductImages(
       *   prepared.uploads,
       *   images.map(({ image }) => image.file!),
       * );
       * await confirmProductImages(productId, ids);
       */
      return new Map(images.map((item, index) => [item.image.id, ids[index]]));
    },
    [],
  );
  return { uploadAndConfirmImages };
}
